module.exports = __webpack_public_path__ + "static/img/s5.d6546d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/s5.png
// module id = 6O9J
// module chunks = 1